import { AppKit } from '@web3modal/base';
import { EVMWagmiClient } from '@web3modal/base/adapters/evm/wagmi';
import { getWeb3Modal } from '@web3modal/base/utils/library/react';
import { ConstantsUtil } from '@web3modal/scaffold-utils';
export { defaultWagmiConfig } from '@web3modal/base/adapters/evm/wagmi';
let appkit = undefined;
let wagmiAdapter = undefined;
export function createWeb3Modal(options) {
    wagmiAdapter = new EVMWagmiClient({
        wagmiConfig: options.wagmiConfig,
        siweConfig: options.siweConfig,
        defaultChain: options.defaultChain
    });
    appkit = new AppKit({
        ...options,
        defaultChain: wagmiAdapter.defaultChain,
        adapters: [wagmiAdapter],
        sdkType: 'w3m',
        sdkVersion: `react-wagmi-${ConstantsUtil.VERSION}`
    });
    getWeb3Modal(appkit);
    return appkit;
}
export { useWeb3ModalTheme, useWeb3Modal, useWeb3ModalState, useWeb3ModalEvents, useWalletInfo } from '@web3modal/base/utils/library/react';
//# sourceMappingURL=index.js.map